export function patch<F1 extends(...args: any) => any, F2 extends (result: ReturnType<F1>, ...args: any) => any>(
    f1: F1,
    f2: F2
): () => () => ReturnType<F1> {
    return function(this: unknown, ...args: any): ReturnType<F1> {
        const result: ReturnType<F1> = f1.apply(this, args);

        f2.apply(this, [result, ...args]);

        return result;
    };
}

export function generateTextureMap(gl: WebGLRenderingContext): Record<GLenum, number> {
    const textureMap: Record<GLenum, number> = {};

    textureMap[gl.TEXTURE_2D] = gl.TEXTURE_BINDING_2D;
    textureMap[gl.TEXTURE_CUBE_MAP] = gl.TEXTURE_BINDING_CUBE_MAP;
    textureMap[gl.TEXTURE_CUBE_MAP_NEGATIVE_X] = gl.TEXTURE_BINDING_CUBE_MAP;
    textureMap[gl.TEXTURE_CUBE_MAP_NEGATIVE_Y] = gl.TEXTURE_BINDING_CUBE_MAP;
    textureMap[gl.TEXTURE_CUBE_MAP_NEGATIVE_Z] = gl.TEXTURE_BINDING_CUBE_MAP;
    textureMap[gl.TEXTURE_CUBE_MAP_POSITIVE_X] = gl.TEXTURE_BINDING_CUBE_MAP;
    textureMap[gl.TEXTURE_CUBE_MAP_POSITIVE_Y] = gl.TEXTURE_BINDING_CUBE_MAP;
    textureMap[gl.TEXTURE_CUBE_MAP_POSITIVE_Z] = gl.TEXTURE_BINDING_CUBE_MAP;

    return textureMap;
}

export function generateTypeMap(gl: WebGLRenderingContext): Record<GLenum, number> {
    const typeMap: Record<GLenum, number> = {};

    typeMap[gl.UNSIGNED_BYTE] = 1;
    typeMap[gl.UNSIGNED_SHORT_4_4_4_4] = 0.5;
    typeMap[36193] = 2;
    typeMap[gl.FLOAT] = 4;

    return typeMap;
}

export function generateFormatMap(gl: WebGLRenderingContext): Record<GLenum, number> {
    const formatMap: Record<GLenum, number> = {};

    formatMap[gl.RGBA] = 4;
    formatMap[gl.RGB] = 3;

    return formatMap;
}
